export const SectionCardStyle = {
    container: 'flex flex-col p-6 w-full h-auto bg-lightBlack rounded-[4px]',
    button: 'flex justify-between',
    buttonText: 'flex justify-between items-end mt-auto',
    absolute: 'absolute -top-3 -right-3 z-2',
}
